export const CHECKIN_SECTION = 'checkIn';
export const HANDOVER_SECTION = 'handover';
export const VEHICLE_INSPECTION_SECTION = 'vehicleInspection';
